import { useTranslation } from 'react-i18next';
export const FreeResponse = () => {
  const [t] = useTranslation();
  return (
    <section className='message-wrapper'>
      <h3>{t('response.free.title')}</h3>
      <p>{t('response.free.information')}</p>
    </section>
  );
};
